import { MenuItem } from '@/eden/theme/sections/header/menu/menu';

type Cockpit = {
  // Home
  home_welcome_images: CustomizeImage[];
  footer_phone_phone: string;
  navigation_head: MenuItem[];
  footer_phone_whatsapp: string;
};

// @ts-ignore
export const cockpit: Cockpit = window.cockpit;
